// extracted by mini-css-extract-plugin
export var cdBundleProductContent = "bundle-products-module--cd-bundle-product-content--70f73";
export var cdBundleProductImg = "bundle-products-module--cd-bundle-product-img--7b303";
export var cdBundleProductImgWrapper = "bundle-products-module--cd-bundle-product-img-wrapper--b3919";
export var cdBundleProductItem = "bundle-products-module--cd-bundle-product-item--d62de";
export var cdBundleProducts = "bundle-products-module--cd-bundle-products--962d0";
export var cdBundleProductsContainer = "bundle-products-module--cd-bundle-products-container--e650d";